import React from 'react'
import CoursePlaylist from '../../Components/client/CoursePlaylist'
function CoursPlaylist() {
  return (
    <div>
      <CoursePlaylist/>
    </div>
  )
}

export default CoursPlaylist
